/* Spintronik: Abspielverhalten des Hero-Videos.
   Wird von sections/spintronik-dach.liquid aufgerufen.

   Zwei Betriebsarten:
   einmal = true   Video laeuft einmal, danach steht das Standbild.
                   Eine Schaltflaeche startet es erneut. Auf dem Handy
                   wird das Video erst beim Antippen geladen.
   einmal = false  Bisheriges Verhalten mit weicher Schleife.
*/
window.spintronikDach = function (o) {
  var wurzel = document.getElementById(o.id);
  if (!wurzel) return;

  var filme = wurzel.querySelectorAll('.film');
  if (!filme.length) return;

  var vorn = wurzel.querySelector('.film.eins');
  var hinten = wurzel.querySelector('.film.zwei');
  if (!vorn) return;

  /* Wer das Video nicht automatisch bekommen soll, bekommt es nicht
     automatisch geladen. Die Adresse steht in data-quelle. */
  function darfLaden() {
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
      if (!o.mobil && window.matchMedia('(max-width: 1000px)').matches) return false;
      var v = navigator.connection;
      if (v) {
        if (v.saveData) return false;
        if (/2g/.test(v.effectiveType || '')) return false;
      }
    } catch (e) {}
    return true;
  }

  function starte(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
    return p;
  }

  if (o.einmal) {
    var knopf = wurzel.querySelector('.nochmal');
    var geladen = false;
    var an = false;

    function lade() {
      if (geladen) return;
      geladen = true;
      vorn.preload = 'auto';
      vorn.src = vorn.getAttribute('data-quelle');
      vorn.load();
    }

    function ausblenden() {
      vorn.style.opacity = 0;
      wurzel.classList.remove('laeuft');
      if (knopf) knopf.hidden = false;
    }

    function spiele() {
      if (knopf) knopf.hidden = true;
      vorn.style.opacity = 1;
      wurzel.classList.add('laeuft');
      var p = vorn.play();
      if (p && p.catch) p.catch(ausblenden);
    }

    vorn.addEventListener('ended', ausblenden);

    if (knopf) {
      knopf.addEventListener('click', function () {
        lade();
        try { vorn.currentTime = 0; } catch (e) {}
        spiele();
      });
    }

    if (darfLaden()) {
      var los = function () {
        if (an) return;
        an = true;
        spiele();
      };
      vorn.addEventListener('canplaythrough', los, { once: true });
      vorn.addEventListener('loadeddata', function () { setTimeout(los, 400); }, { once: true });
      lade();
    } else if (knopf) {
      knopf.hidden = false;
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) vorn.pause();
    });
    return;
  }

  /* Ab hier das bisherige Verhalten mit Schleife. */
  if (!darfLaden()) return;

  var gestartet = false;

  function beobachte() {
    var a = vorn, b = hinten;
    function pruefe() {
      if (!a.duration || !isFinite(a.duration)) return;
      if (a.duration - a.currentTime > o.blende / 1000) return;
      if (!b.paused) return;
      try { b.currentTime = 0; } catch (e) {}
      starte(b);
      b.style.opacity = 1;
      a.style.opacity = 0;
      var alt = a;
      setTimeout(function () {
        alt.pause();
        try { alt.currentTime = 0; } catch (e) {}
      }, o.blende + 80);
      var t = a; a = b; b = t;
    }
    vorn.addEventListener('timeupdate', pruefe);
    if (hinten) hinten.addEventListener('timeupdate', pruefe);
  }

  function zeige() {
    if (gestartet) return;
    gestartet = true;
    starte(vorn);
    vorn.style.opacity = 1;
    wurzel.classList.add('laeuft');
    if (o.weich && hinten) beobachte();
  }

  vorn.addEventListener('canplaythrough', zeige, { once: true });
  vorn.addEventListener('loadeddata', function () { setTimeout(zeige, 400); }, { once: true });

  vorn.preload = 'auto';
  vorn.src = vorn.getAttribute('data-quelle');
  if (hinten) {
    hinten.preload = 'auto';
    hinten.src = hinten.getAttribute('data-quelle');
  }
  vorn.load();

  document.addEventListener('visibilitychange', function () {
    for (var i = 0; i < filme.length; i++) {
      if (document.hidden) filme[i].pause();
      else if (parseFloat(filme[i].style.opacity) > 0) starte(filme[i]);
    }
  });
};
